import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于黑料每日大赛，你可能想了解的事情
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqData.map((faq) => (
            <div key={faq.id} className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-600 font-bold text-xs">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-2">{faq.question}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}